import { TBulkPricingItem } from 'product/_models';

export function getUnitPriceFromPriceRange(quantity: number, priceRanges: TBulkPricingItem[], defaultPrice: number): number {
  const currentPriceRange = priceRanges.find(
    priceRange => quantity >= priceRange.minimumAmount && quantity <= priceRange.maximumAmount,
  );
  return currentPriceRange ? currentPriceRange.unitPrice : defaultPrice;
}
